Vue.component("backgroundBodyText", {
    props: ["config"],
    template: `
        <div class="backgroundBodyText" :style="[wrapperPosition, getWidth, getColor]">
            <h3 v-html="config.title" :style="[getTitleSize]" v-if="config.hasOwnProperty('title')"></h3>
            <p v-html="config.text" :style="[getTextSize]" v-if="config.hasOwnProperty('text')"></p>
        </div>
    `,
    data() {
        return {

        }
    },
    methods: {

    },
    computed: {
        wrapperPosition() {
            return {
                left: this.config.positionX + 'px',
                top: this.config.positionY + 'px'
            }
        },
        getWidth() {
            return {
                width: this.config.width !== (undefined || "") ? this.config.width : "auto"
            }
        },
        getColor() {
            return {
                color: this.config.color
            }
        },
        getTitleSize() {
            return {
                "font-size": this.config.titleSize
            }
        },
        getTextSize() {
            return {
                "font-size": this.config.textSize
            }
        }
    }
});